<template>
  <div v-if="keyValues.length > 0" class="ds-key-value-docs">
    <table class="table mts">
      <thead>
        <tr>
          <th>Key</th>
          <th>Type</th>
          <th>Description</th>
        </tr>
      </thead>
      <tbody>
        <template v-for="(kv, idx) in keyValues" :key="'tr_' + idx">
          <tr>
            <td>{{ kv.key }}</td>
            <td>{{ kv.type }}</td>
            <td>
              <div v-html="kv.desc"></div>
              <div v-if="kv.values">
                <div>Values</div>
                <dl class="dl">
                  <template
                    v-for="(val, idx2) in kv.values"
                    :key="'dt_' + idx2"
                  >
                    <dt class="dt">{{ val.value }}</dt>
                    <dd class="dd" v-html="val.desc"></dd>
                  </template>
                </dl>
              </div>
            </td>
          </tr>
        </template>
      </tbody>
    </table>
  </div>
</template>
<script lang="ts">
import { Component, Prop, Vue } from "vue-facing-decorator";
import { KeyValueDoc, GlueDocs } from "./glue-documentation-types";

@Component({ name: "key-value-docs" })
export default class GlueDocDisplayOptions extends Vue {
  @Prop(String)
  public readonly componentName!: string;

  get keyValues(): KeyValueDoc[] {
    const doc: GlueDocs = window[this.componentName + "-docs"];
    if (doc != null) {
      if (doc.keyValues) {
        return doc.keyValues;
      }
    }
    return [];
  }
}
</script>
